import React, { useEffect, useState } from 'react'
import TestForwardandBackward from '../TestQuestion/TestForwardandBackward';
import { MdOutlineClose } from 'react-icons/md';
import { GiNotebook } from 'react-icons/gi';
import { IoMdRefresh } from 'react-icons/io';
import { useLocation, useNavigate } from 'react-router-dom';


interface TestQuestion {
	question: string;
	a: string;
	b: string;
	c: string;
	d: string;
	score: number;
	id: number;
	ans: string;
	correctAns: string;
}
const TestPreview = () => {
	const location = useLocation()
	const navigate = useNavigate();
	const [active, setActive] = useState(1)
	// @ts-ignore  
	const data = location?.state?.data;


	const [testscore, setTestscore] = useState<TestQuestion[]>([]);
	const [displayData, setDisplayData] = useState<TestQuestion[]>([]);


	useEffect(() => {
		const testQuestions = data?.map((item, index) => ({
			question: item.question,
			a: item.optionA,
			b: item.optionB,
			c: item.optionC,
			d: item.optionD,
			score: item.score,
			id: index + 1,
			ans: "",
			correctAns: item.correctAnswer === "optionA" ? "a" :
				item.correctAnswer === "optionB" ? "b" :
					item.correctAnswer === "optionC" ? "c" : "d",
		}));
		setTestscore(testQuestions);
	}, [data]);

	useEffect(() => {
		if (testscore) {
			const result = testscore?.filter((data) => data.id === active);
			setDisplayData(result);
		}
	}, [active, testscore]);

	const calculateScore = () => {
		const scores = testscore?.map((item) => item.score);
		const totalScore = scores?.reduce((x, y) => x + y, 0);
		return totalScore;
	};

	const handleChange = (input, value, item) => {
		let items = [...testscore];
		let oldItem = items.findIndex((x) => x.id === item.id);
		let newItem = { ...items[oldItem], [input]: value, score: item.correctAns === value ? 5 : 0 };
		items[oldItem] = newItem;
		setTestscore(items);
	};

	const incrementCountCancel = () => {
		// Update state back to one
		setActive(1);
	};

	const handleBack = () => {
		navigate(-1);
	};

	return (
		<div>
			<header className="ChatProgressView-header">
				<div className='Update-titile-icon'>
					<GiNotebook color='#0b03fc' />
					<div className="in-progresss">
						Test Preview
					</div>
				</div>

				<div className="ChatProgressView-close" onClick={handleBack}>
					<MdOutlineClose
						size={25}
						style={{ color: "white", backgroundColor: "" }}
						className="ChatProgressView-close-icon"
					/>
				</div>
			</header>

			<div id="body-questions">
				{active === testscore.length + 1 ?
					<div className='quizeanswer'>
						<h3>Your scored</h3>
						<div className="scoreBoard">
							<span className="scoreCount">{calculateScore()}</span>
							<button className="btn" onClick={incrementCountCancel}>
								<IoMdRefresh /> again
							</button>
						</div>
					</div> : displayData?.map((item) => (
						<div className="quize" key={item.id}>
							<div className="question-bar">
								<h2 className="qestion">{item.id}) {item.question}</h2>

								<ul>
									<li>
										<input type="radio" name={`option-${item.id}`} id={`a-${item.id}`} className="ansList"
											checked={item.ans === 'a'}
											onChange={() => handleChange("ans", 'a', item)} />
										<label htmlFor={`a-${item.id}`} className="ansa">{item.a}</label>
									</li>
									<li>
										<input type="radio" name={`option-${item.id}`} id={`b-${item.id}`} className="ansList"
											checked={item.ans === 'b'}
											onChange={() => handleChange("ans", 'b', item)} />
										<label htmlFor={`b-${item.id}`} className="ansb">{item.b}</label>
									</li>
									<li>
										<input type="radio" name={`option-${item.id}`} id={`c-${item.id}`} className="ansList"
											checked={item.ans === 'c'}
											onChange={() => handleChange("ans", 'c', item)} />
										<label htmlFor={`c-${item.id}`} className="ansc">{item.c}</label>
									</li>
									<li>
										<input type="radio" name={`option-${item.id}`} id={`d-${item.id}`} className="ansList"
											checked={item.ans === 'd'}
											onChange={() => handleChange("ans", 'd', item)} />
										<label htmlFor={`d-${item.id}`} className="ansd">{item.d}</label>
									</li>
								</ul>
								<div className="footer-button">
									<TestForwardandBackward setActive={setActive} active={active} calculateScore={calculateScore} />
								</div>
							</div>
							<div id="showscore" className="scoreArea" style={{ color: "#0b03fc", fontWeight: "bold", fontSize: "20px" }}>{item.id} of {testscore.length}</div>
						</div>
					))}
			</div>
		</div>
	)
}

export default TestPreview
